import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector, { CustomDetector } from 'i18next-browser-languagedetector';
import en from './translations/en.json';
import es from './translations/es.json';

const resources = {
  en,
  es,
};

export type SupportedLanguages = keyof typeof resources;

export const SupportedLanguageDisplay = [
  {
    displayName: 'English',
    languageKey: 'en' as SupportedLanguages,
    changeText: 'Changing to English... Cambiando a ingles...',
  },
  {
    displayName: 'Español - Spanish',
    languageKey: 'es' as SupportedLanguages,
    changeText: 'Changing to Spanish... Cambiando a español...',
  },
];

export enum DeviceInformationMapping {
  'en' = 'english',
  'es' = 'spanish'
}

// This flag conrols language selection screen on landing page
const HAS_USER_SET_LANGUAGE = 'HAS_USER_SET_LANGUAGE';

const I18N_LANGUAGE = 'i18nextLng';

export const getHasUserSetLanguage = () => {
  return localStorage.getItem(HAS_USER_SET_LANGUAGE);
};

export const setHasUserSetLanguage = (value: string) => {
  return localStorage.setItem(HAS_USER_SET_LANGUAGE, value);
};

export const getLanguageFromLocalStorage = () => {
  return localStorage.getItem(I18N_LANGUAGE);
};

const setLanguageLocalStorage = (language: SupportedLanguages) => {
  return localStorage.setItem(I18N_LANGUAGE, language);
};

const detector: CustomDetector = {
  name: 'LanguageDetector',
  lookup: () => {
    return getLanguageFromLocalStorage() ?? 'en';
  },
  cacheUserLanguage: (language: SupportedLanguages, _options) => {
    setLanguageLocalStorage(language);
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(detector);
languageDetector.init(null, { order: ['LanguageDetector'] });

i18n.use(languageDetector).use(initReactI18next).init({
  resources,
  defaultNS: 'common',
  fallbackLng: 'en',
});

export default i18n;
